const orgName = 'Auth0';

/**
 * Expose `title`s resolve function
 */

export default function resolve(str, append, single) {
  if (!str) return orgName;
  if (single) return str;

  return append ? `${orgName} - ${str}` : `${str} - ${orgName}`;
}



// WEBPACK FOOTER //
// ./src/modules/title/resolve.js